(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gm-local-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gm-local-delivery')) {
class GMLocalDelivery extends HTMLElement {
 connectedCallback() {
  if(this.ready)return;this.ready=true;
  this.ids=['68057314066645','68057314099413','68057314132181','68057314164949','68057314197717','68057314230485','68057314263253','68057314296021'];
  this.distance=this.querySelector('[data-distance]');this.service=this.querySelector('[data-service]');this.status=this.querySelector('[data-status]');
  const index=this.ids.indexOf(this.dataset.current.trim());
  if(index>=0){this.distance.value=String(index%4);this.service.value=String(Math.floor(index/4));}
  this.addEventListener('change',()=>this.price());
  this.querySelector('[data-apply]').addEventListener('click',()=>this.apply());
  this.price();
 }
 price(){
  const selected=this.service.value!==''&&this.distance.value!=='';
  this.querySelector('[data-price]').textContent=selected?new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(160+50*Number(this.distance.value)+40*Number(this.service.value)):'';
 }
 async apply(){
  if(window.gmDeliveryBusy)return;
  if(this.service.value!==''&&this.distance.value===''){this.status.textContent=this.status.dataset.distanceError;this.distance.focus();return;}
  window.gmDeliveryBusy=true;
  const controls=Array.from(document.querySelectorAll('[name="checkout"],gm-local-delivery button,gm-local-delivery select'));
  const previous=controls.map(e=>e.disabled);controls.forEach(e=>e.disabled=true);
  this.status.textContent=this.status.dataset.saving;
  const root=window.Shopify?.routes?.root||'/';
  try{
   const beforeResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
   if(!beforeResponse.ok)throw new Error('cart');
   const before=await beforeResponse.json();
   const updates={};
   const selected=this.service.value===''?null:this.ids[Number(this.service.value)*4+Number(this.distance.value)];
   let kept=false;
   before.items.filter(i=>this.ids.includes(String(i.variant_id))).forEach(i=>{const keep=!kept&&String(i.variant_id)===selected;updates[i.key]=keep?1:0;if(keep)kept=true;});
   if(selected&&!kept)updates[selected]=1;
   const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
   const cart=await response.json();
   if(!response.ok||cart.errors||!cart.items)throw new Error('update');
   const services=cart.items.filter(i=>this.ids.includes(String(i.variant_id)));
   if(selected?(services.length!==1||String(services[0].variant_id)!==selected||services[0].quantity!==1):services.length!==0)throw new Error('verify');
   window.location.assign(root+'cart'+window.location.search);
  }catch(error){
   this.status.textContent=this.status.dataset.error;
   controls.forEach((e,i)=>e.disabled=previous[i]);window.gmDeliveryBusy=false;
  }
 }
}
customElements.define('gm-local-delivery',GMLocalDelivery);
}
  } catch(e) { console.error(e); }
})();

})();
